import EmojiAddIcon from '@atlaskit/icon/core/emoji-add';
import * as React from 'react';

export function SvgSmileSelect() {
  return <EmojiAddIcon label="" testId="ads-refreshed-icon" />;
}
